import React from "react"
import styled, {css} from "styled-components"
import {media} from "utils/Media"
import quoteRed from 'images/Interactive/quote-red.svg';
import quoteOrange from 'images/Interactive/quote-orange.svg';
import quoteGreen from 'images/Interactive/quote-green.svg';

const InfoBox = styled.div`
    position: absolute;
    z-index: 8;
    pointer-events: none;
    background-color: ${props => props.theme.colors.white};
    width: 98%;
    height: 90px;
    right: 0;
    transform: none;
    bottom: 100px;
    
    @media ${media.sm} {
        bottom: 200px;
        width: 300px;
    }
    
    @media ${media.lg} {
        bottom: initial;
        top: 50%;
        transform: translateY(-50%);
    }
    
    ${props => props.big && css`
        height: 140px;
    `}

    p {
        color: ${props => props.theme.colors.black};
        font-family: ${props => props.theme.font.family.semiBold};
        font-size: 1.25rem;
        line-height: 120%;
        letter-spacing: 0.03em;
        padding: 0.5rem 1rem;
    }
`

InfoBox.defaultProps = {
}

export default InfoBox